import React, {FC} from 'react';

import {ConversationModel} from '../../models/api/conversationModel';
import {InboxesVisualConversationSelection} from '../../store/panels/cells/helpers/cellsPanelSelectionHelpers';
import {ViewerPanelId} from '../../store/panels/panelStateBase';
import {ViewerPanelPageState} from '../../store/panels/viewer/viewerPanelState';
import {FrameTitle} from '../common/frames/frameTitle';
import {InboxesTopbar} from '../inboxes/topbar/inboxesTopbar';
import {ConversationHeaderContainer} from '../inboxes/viewer/conversation/header/conversationHeaderContainer';
import {ConversationSubjectContainer} from '../inboxes/viewer/conversation/header/conversationSubjectContainer';
import {NewConversationTopbarContainer} from '../inboxes/viewer/conversation/topbar/conversationTopbarContainer';
import {ViewerContainer} from '../inboxes/viewer/viewerContainer';

/*
 * Props.
 */

interface PopupViewerConversationProps {
  panelId: ViewerPanelId;
  conversation: ConversationModel | undefined;
  page: ViewerPanelPageState;
  conversationSelection: InboxesVisualConversationSelection;
  shouldFocusComment?: boolean;
}

/*
 * Component.
 */

export const PopupViewerConversation: FC<PopupViewerConversationProps> = (props) => (
  <>
    <FrameTitle>
      {props.conversation && (
        <ConversationSubjectContainer
          teammateId={props.page.cellsContext.teammateId}
          conversation={props.conversation}
        />
      )}
    </FrameTitle>
    <InboxesTopbar
      panelId={props.panelId}
      cellsPanelId={undefined}
      isInPopup
      filters={undefined}
      cellsContext={props.page.cellsContext}
      parameters={props.page.parameters}
      conversationSelection={props.conversationSelection}
    />
    <ViewerContainer
      panelId={props.panelId}
      cellsPanelId={undefined}
      topbar={
        <NewConversationTopbarContainer
          panelId={props.panelId}
          cellsPanelId={undefined}
          isInPopup
          cellsContext={props.page.cellsContext}
          inboxesParameters={props.page.parameters}
          conversationSelection={props.conversationSelection}
        />
      }
      header={
        <ConversationHeaderContainer
          panelId={props.panelId}
          cellsPanelId={undefined}
          cellsContext={props.page.cellsContext}
          inboxesParameters={props.page.parameters}
          conversationSelection={props.conversationSelection}
        />
      }
      contentPage={props.page}
    />
  </>
);
